/**
 * useBreakpoint — семантические булевы по ширине окна (matchMedia).
 * Границы совпадают с Tailwind: md=768, lg=1024.
 *
 *  - isMobile:  < 768   → телефоны
 *  - isTablet:  < 1024  → телефоны + планшеты
 *  - isDesktop: ≥ 1024  → ноуты/мониторы
 */

import {useEffect, useState} from 'react';

export type UseBreakpointResult = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const query = (min: number) => `(min-width: ${min}px)`;

const read = (min: number): boolean =>
  typeof window !== 'undefined' && window.matchMedia(query(min)).matches;

export const useBreakpoint = (): UseBreakpointResult => {
  const [mdUp, setMdUp] = useState(() => read(768));
  const [lgUp, setLgUp] = useState(() => read(1024));

  useEffect(() => {
    const md = window.matchMedia(query(768));
    const lg = window.matchMedia(query(1024));
    const onMd = () => setMdUp(md.matches);
    const onLg = () => setLgUp(lg.matches);
    md.addEventListener('change', onMd);
    lg.addEventListener('change', onLg);
    return () => {
      md.removeEventListener('change', onMd);
      lg.removeEventListener('change', onLg);
    };
  }, []);

  return {isMobile: !mdUp, isTablet: !lgUp, isDesktop: lgUp};
};
